import { render, staticRenderFns } from "./garden25.vue?vue&type=template&id=44916906&scoped=true"
import script from "./garden25.vue?vue&type=script&lang=js"
export * from "./garden25.vue?vue&type=script&lang=js"
import style0 from "./garden25.vue?vue&type=style&index=0&id=44916906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44916906",
  null
  
)

export default component.exports